<mat-expansion-panel class="questions-list-container" #panel hideToggle [(expanded)]="expanded"
  (click)="preventPanelToggle()">
  <mat-expansion-panel-header>
    <div [ngClass]="{'stepper-header-container-with-content':enableHeaderContent}" class="stepper-header-container">
      <div class="content-container">
        <ng-content> </ng-content>
      </div>
      <div class="title-container">
        <p class="thick">
          {{title(questions ? questions[questionIndex] : null )}}
        </p>
      </div>
      <div class="btns-container">
        <button
          [ngClass]="deactivateNavigation || questionListEmpty || questionIndex === 0 ? 'nav-btn-disabled' : 'nav-btn'"
          (click)="stepBack()">
          <mat-icon> keyboard_arrow_left</mat-icon>
        </button>
        <button [ngClass]="
             deactivateNavigation || questionListEmpty || questionIndex === questions?.length - 1
              ? 'nav-btn-disabled'
              : 'nav-btn'
          " (click)="stepForward()">
          <mat-icon> keyboard_arrow_right</mat-icon>
        </button>
      </div>
    </div>
  </mat-expansion-panel-header>
  @if (!questionListEmpty) {
    <div class="question-stepper"
      [ngStyle]="{'filter': loading ? 'blur(0.2rem)' : 'blur(0)' , 'pointer-events': loading ? 'none' : '' }">
      <div class="question-Designation">
        {{ questions && questions[questionIndex]?.Designation }}
      </div>
      <abc-radio-group #radioGroup [disabled]="loading" [items]="options ?? []" [value]="response"
        (onValueChanged)="radioChange($event)" class="radio-group">
      </abc-radio-group>
      <div class="footer-btns-container"
        [fxLayoutAlign]="questionDescription ? 'space-between center' : 'flex-end center'">
        @if (questionDescription) {
          <i class="dx-icon-info" id="btn-description" (mouseenter)="togglePopover()"
          (mouseleave)="togglePopover()"></i>
        }
        <ng-content select="#footerContent"></ng-content>
        <dx-popover target="#btn-description" position="top" [width]="300" [(visible)]="descriptionPopoverVisible">
          <div>
            {{ questionDescription }}
          </div>
        </dx-popover>
      </div>
    </div>
  }
  @if (questionListEmpty) {
    <div class="no-question-container">
      <p> {{labels.NoQuestion}} </p>
    </div>
  }
  @if (loading) {
    <iddat-loader></iddat-loader>
  }
</mat-expansion-panel>